import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import { CfAsset } from '../asset';
import { mapCfEntityToCfMarketingBlock } from './mapper';

export class CfMarketingBlock {
    static contentType = contentTypes.CfMarketingBlock;

    static mapCfEntity = mapCfEntityToCfMarketingBlock;

    constructor(data) {
        this.description = data.description;
        this.title = data.title;
        this.image = data.image && new CfAsset(data.image);
    }
}
